import React, { useEffect, useState } from 'react';
import DataTable from '../common/DataTable';
import { CarrierProfitReportsColumns, numOfPage } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import BatchPagination from '../batch/BatchPagination';
import LoaderSpinner from '../common/Loader';
import _ from 'lodash';
import MonthFilter from '../common/MonthFilter';
import "./style.css";
import { toast } from 'react-toastify';
import { getCarrierProfitReports } from '../../store/actions/carrierReconciliationReport.action';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { formatNumberWithCommas, formatStaticNumberWithCommas } from '../../config/utils';

/*istanbul ignore next */
const CarrierProfitReports = () => {
    const [showLoader, setShowLoader] = useState(false);
    const { pnlReportListing, pnlReportListingStatus } = useSelector((state) => state.carrierReconciliationReport);
    let dispatch = useDispatch();
    const now = new Date();
    const [reportListing, setReportListing] = React.useState([]);
    const navigate = useNavigate();
    const [totalData, setTotalData] = React.useState({});
    const [filterData, setfilterData] = useState({
        pageIndex: 1,
        pageSize: 30,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        startDate: new Date(now.getFullYear(), now.getMonth(), 1),
        endDate: new Date(now.getFullYear(), now.getMonth() + 1, 0),
        reportType: 'USPSPREMIUM'
    });
    
    useEffect(() => {
        if (pnlReportListing?.monthlyStatements?.length){
            setReportListing(pnlReportListing.monthlyStatements);
        }
        setTotalData(pnlReportListing.carrierTotals);
    }, [pnlReportListing]);
    
    useEffect(() => {
        fetchReportData();
    }, [filterData.pageSize, filterData.pageIndex, filterData.sortColumn, filterData.sortOrder]);

    const fetchReportData = async () => {
        try {
            let payload = {
                ...filterData,
                startDate: moment(filterData.startDate).format("YYYY-MM-DDT00:00:00"),
                endDate: moment(filterData.endDate).format("YYYY-MM-DDT00:00:00"),
            };
            dispatch(getCarrierProfitReports(payload));
        } catch (error) {
            console.error("Error fetching report data", error);
        }
    };

    useEffect(() => {
        if (pnlReportListingStatus === 'PENDING') {
            setShowLoader(true);
        } else if (pnlReportListingStatus === 'SUCCESS' && !_.isEmpty(filterData)) {
            setfilterData({
                ...filterData,
                totalPages: Math.ceil(pnlReportListing?.totalRecords / filterData.pageSize),
            });
            setShowLoader(false);
        }
    }, [pnlReportListingStatus]);

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
            pageIndex: 1
        });
    };

    const handleApplyFilter = (data) => {
        if(!data.startDate && !data.endDate){
            toast.error("Please select both From Month and To Month");
            return;
        }

        if (filterData.pageIndex === 1) {
            setfilterData({
                ...filterData,
                startDate: data.startDate,
                endDate: data.endDate,
                reportType: data.reportType
            });
            let payload = {
                ...filterData,
                startDate: moment(data.startDate).format("YYYY-MM-DDT00:00:00"),
                endDate: moment(data.endDate).format("YYYY-MM-DDT00:00:00"),
                reportType: data.reportType
            };
            dispatch(getCarrierProfitReports(payload));
        } else {
            setfilterData({
                ...filterData,
                startDate: data.startDate,
                endDate: data.endDate,
                pageIndex: 1
            });
        }
    };

    return (
        <main className="carrier-reconciliation-reports">
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec zIndex3">
                    <span>Carrier Profitability Reports</span>
                    <div className="top_right_button_container">
                        <button className="btn cus-primary-transparent-btn mr-2" onClick={() => navigate("/reports")}>Back</button>
                        <button disabled={showLoader} className="btn cus-seconday-bg-btn" onClick={() => setfilterData({ ...filterData, showFilter: !filterData.showFilter })}>Filter</button>
                    </div>
                </div>
                {showLoader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}

                <div className='zIndex2 mb-3'>
                    {filterData.showFilter && (
                        <MonthFilter handleApplyFilter={handleApplyFilter} loader={showLoader}/>
                    )}
                </div>

                <div className="reportCardContainer">
                    <div className="card">
                        <h3>Total Records</h3>
                        <p>{formatStaticNumberWithCommas(totalData?.totalRecordCount || 0)}</p>
                    </div>
                    <div className="card">
                        <h3>Total Shipments</h3>
                        <p>{formatStaticNumberWithCommas(totalData?.totalShipments || 0)}</p>
                    </div>
                    <div className="card">
                        <h3>Total Revenue ($)</h3>
                        <p className={totalData?.totalRevenue <= 0 ? 'pending' : 'credit'}>{`$ ${formatNumberWithCommas(totalData?.totalRevenue || 0)}`}</p>
                    </div>
                    <div className="card">
                        <h3>Carrier Revenue ($)</h3>
                        <p className={totalData?.carrierRevenue <= 0 ? 'pending' : 'credit'}>{`$ ${formatNumberWithCommas(totalData?.carrierRevenue || 0)}`}</p>
                    </div>
                    <div className="card">
                        <h3>Net Profit/Loss ($)</h3>
                        <p className={totalData?.netProfitLoss <= 0 ? 'pending' : 'credit'}>{`$ ${formatNumberWithCommas(totalData?.netProfitLoss || 0)}`}</p>
                    </div>
                </div>

                <div className="main_content cus-page-content-sec srch-pt0 zIndex1">
                    <div className="main_content_table_history">
                        <div className="tableFixHead incomingTbl center-aligned-table">
                            <DataTable
                                tableData={pnlReportListing?.monthlyStatements || []}
                                headers={CarrierProfitReportsColumns}   
                                handleSortingColumn={handleSortingColumn}
                                tableDataStatus={pnlReportListingStatus}
                                filterData={filterData}
                            />
                        </div>
                    </div>
                    {pnlReportListing?.monthlyStatements?.length > 0 && (
                        <BatchPagination
                            gridData={reportListing}
                            totalVisualRecords={reportListing.length}
                            numberOfPage={filterData.pageSize}
                            numOfPage={numOfPage}
                            loader={showLoader}
                            currentPage={filterData.pageIndex}
                            totalPages={filterData.totalPages}
                            totalRecords={pnlReportListing?.totalRecords}
                            setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                            setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value, pageIndex: 1 })}
                        />
                    )}
                </div>
            </div>
        </main>
    );
}


export default CarrierProfitReports;